export default "__VITE_ASSET__5qc$6HIB__"